import { cn } from "@/lib/utils";
import { NvCheckbox } from "./nv-checkbox";

// 동의 항목 박스 (Figma ver.6 546:1428 "동의 항목", r12): 모두 동의(500 15/18) + 구분선 #DFE3E6 + 항목들, 전문 보기 링크
export interface NvConsentItem {
  code: string;
  label: string;
  // Shows "전문 보기 ›" that opens the terms popup at this code
  viewable?: boolean;
}

export interface NvConsentBoxProps {
  items: NvConsentItem[];
  checked: Record<string, boolean>;
  onChange: (next: Record<string, boolean>) => void;
  onView: (code: string) => void;
  className?: string;
}

function NvConsentBox({ items, checked, onChange, onView, className }: NvConsentBoxProps) {
  const allChecked = items.every((item) => checked[item.code]);
  return (
    <div className={cn("flex flex-col gap-3 rounded-nv-card border border-nv-border bg-nv-surface p-5", className)}>
      <NvCheckbox
        checked={allChecked}
        onCheckedChange={(on) => onChange(Object.fromEntries(items.map((item) => [item.code, on])))}
        label="모두 동의합니다"
        labelClassName="text-[15px] font-medium leading-[18px]"
      />
      <hr className="border-nv-divider" />
      {items.map((item) => (
        <div key={item.code} className="flex items-center justify-between">
          <NvCheckbox
            checked={!!checked[item.code]}
            onCheckedChange={(on) => onChange({ ...checked, [item.code]: on })}
            label={item.label}
          />
          {item.viewable && (
            <button type="button" onClick={() => onView(item.code)} className="text-[12px] leading-[14px] text-nv-text-secondary hover:text-nv-text-primary">
              전문 보기 ›
            </button>
          )}
        </div>
      ))}
    </div>
  );
}

export { NvConsentBox };
